import { Environment } from ".";
import { environment as environmentProd } from "./environment.prod";

export const environment: Environment = {
  ...environmentProd,
  guestUrl: "https://guest-beta.jugl.com",
  featureFlags: {
    maxChatAttachmentsCount: 10,
  },
};
